// import BarcodeManager from "./BarcodeManager.jsx";
// import React, { useEffect, useState } from "react";

// export default function ProductBarcodePage() {
//   const [barcodeData, setBarcodeData] = useState([]);
//   const [batchList, setBatchList] = useState([]);
//   const [productList, setProductList] = useState([]);
//   const [show, setShow] = useState(false);

//   useEffect(() => {
//     setBatchList([{ id: 1, product_code: "P001", batch_no: "B001", mrp: 100 }]);
//     setProductList([{ product_code: "P001", title: "Sample Product" }]);
//     setBarcodeData(["P001-B001", "P001-B001", "P001-B001"]);
//   }, []);

//   // ⭐ AUTO OPEN MODAL
//   useEffect(() => {
//     if (barcodeData.length > 0) {
//       setShow(true);
//     }
//   }, [barcodeData]);

//   return (
//     <div style={{ padding: 20 }}>
      

//       <BarcodeManager
//         barcodeData={barcodeData}
//         batchList={batchList}
//         productList={productList}
//         applicableDate={new Date()}
//         show={show}
//         onClose={() => {}}
//       />
//     </div>
//   );
// }
import BarcodeManager from "./BarcodeManager.jsx";
import React, { useEffect, useState } from "react";

export default function ProductBarcodePage() {
  const [barcodeData, setBarcodeData] = useState([]);
  const [batchList, setBatchList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setBatchList([{ id: 1, product_code: "P001", batch_no: "B001", mrp: 100 }]);
    setProductList([{ product_code: "P001", title: "Sample Product" }]);
    setBarcodeData(["P001-B001", "P001-B001", "P001-B001"]);
  }, []);

  return (
    <div style={{ padding: 20 }}>

      {/* ⭐ BUTTON TO OPEN BARCODE MANAGER ⭐ */}
      <button
        style={{
          background: "green",
          color: "white",
          padding: "10px 20px",
          borderRadius: "6px",
          border: "none",
          cursor: "pointer",
          marginBottom: "20px",
          fontSize: "16px",
        }}
        onClick={() => setShow(true)}
      >
        Barcode
      </button>

      {/* ⭐ BARCODE MANAGER MODAL ⭐ */}
      <BarcodeManager
        barcodeData={barcodeData}
        batchList={batchList}
        productList={productList}
        applicableDate={new Date()}
        show={show}
        onClose={() => setShow(false)}
      />
    </div>
  );
}
